const locale = {
	// #region Commercial Campaigns fields
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_TITLE: 'Titolo',
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_STATUS: 'Stato Campagna Commerciale',
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_TYPE: 'Tipo Campagna Commerciale',
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_ASSIGNED_USER: 'Utente assegnato interno',
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_ASSIGNED_USER_2: 'Utente assegnato esterno',
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_DATE_FROM: 'Data inizio',
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_DATE_TO: 'Data fine',
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_PROGRESS: 'Progresso',
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_WARNING: 'Warning',
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_BLOCKED: 'Bloccato',
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_TAGS: 'Tag',
	DETAILS_COMMERCIALCAMPAIGNS_FIELD_EXPENSES: 'Spese',
	// #endregion

	// #region Commercial Campaigns details right sidebar
	COMMERCIALCAMPAIGNS_STATS_SECTION: 'Statistiche',
	COMMERCIALCAMPAIGNS_STATISTICS_VALUE_EXPENSES: 'Spese',
	COMMERCIALCAMPAIGNS_STATISTICS_VALUE_PLANNED: 'Valore Opportunità',
	COMMERCIALCAMPAIGNS_STATISTICS_N_OPPORTUNITIES: 'N° Opportunità',
	COMMERCIALCAMPAIGNS_STATISTICS_N_LEADS: 'Nuovi Lead',
	COMMERCIALCAMPAIGNS_STATISTICS_N_CUSTOMERS: 'Nuovi Clienti',
	COMMERCIALCAMPAIGNS_STATISTICS_LEAD_CONVERSION: 'Rateo Conversione Lead',
	COMMERCIALCAMPAIGNS_STATISTICS_CAC: 'Costo Acquisizione Cliente (CAC)',
	COMMERCIALCAMPAIGNS_STATISTICS_CPA: 'Costo per Azione (CPA)',
	// #endregion

	// #region Commercial Campaigns Add Rows section
	COMMERCIALCAMPAIGNS_SECTION_ADD_TITLE: 'Aggiungi alla lista',
	COMMERCIALCAMPAIGNS_SECTION_ADD_DESCRIPTION_COMPANIES:
		"Aggiungi alla lista un'Azienda nuova o già conosciuta che ha partecipato a questa Campagna Commerciale (se non presente verrà anche aggiunta automaticamente al database e sarà disponibile per l'utilizzo in qualsiasi azione di recall in futuro).",
	COMMERCIALCAMPAIGNS_SECTION_ADD_DESCRIPTION_PEOPLE:
		"Aggiungi alla lista una Persona nuova o già conosciuta che ha partecipato a questa Campagna Commerciale (se non presente verrà anche aggiunta automaticamente al database e sarà disponibile per l'utilizzo in qualsiasi azione di recall in futuro).",

	COMMERCIALCAMPAIGNS_SECTION_ADD_COMPANIES_TITLE: 'Aggiungi Aziende filtrate',
	COMMERCIALCAMPAIGNS_SECTION_ADD_PEOPLE_TITLE: 'Aggiungi Persone filtrate',

	COMMERCIALCAMPAIGNS_SECTION_COPY_TITLE: 'Importa da',
	COMMERCIALCAMPAIGNS_SECTION_COPY_MARKETINGACTION: 'Azione di Marketing',
	COMMERCIALCAMPAIGNS_SECTION_COPY_DEM: 'DEM',
	COMMERCIALCAMPAIGNS_SECTION_COPY_COMMERCIALCAMPAIGN: 'Campagna Commerciale',

	COMMERCIALCAMPAIGNS_DIALOG_TITLE_ADD_RESULT: 'Vuoi aggiungere questi elementi?',
	// #endregion

	// #region Commercial Campaigns Delete Rows section
	COMMERCIALCAMPAIGNS_SECTION_EMPTY_TITLE: 'Svuota la lista',
	COMMERCIALCAMPAIGNS_SECTION_EMPTY_DESCRIPTION:
		'Tramite questa funzione puoi svuotare tutta la lista (eliminando TUTTI gli elementi aggiunti)',
	COMMERCIALCAMPAIGNS_EMPTY_BUTTON_CLEAR: 'Svuota'
	// #endregion
};

export default locale;
